import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { VERIFIED_BADGE_ENABLED } from "@/components/VerifiedBadge";

export function useCoachVerifications() {
  const [statuses, setStatuses] = useState({});
  useEffect(() => {
    if (!VERIFIED_BADGE_ENABLED) return;
    api
      .get("/coach-verifications")
      .then((r) => setStatuses(r.data || {}))
      .catch(() => setStatuses({}));
  }, []);
  return statuses;
}
